import _ from 'lodash';
import createLinkPlugin from './draft-js-anchor-plugin';
import createLinkifyPlugin from '@draft-js-plugins/linkify';
import TrackEventLink from '../../track-event-link/TrackEventLink';
import linkifyIt from 'linkify-it';
import SingleInputWithOkAndCancel from '../../input-and-go/SingleInputWithOkAndCancel';
import styles from './link-toolbar.module.less';
import tlds from 'tlds';

const linkify = linkifyIt();

export const linkifyPlugin = createLinkifyPlugin({
    customExtractLinks: (text) => getHttpsPrefixToLinks(text),
});

const getHttpsPrefixToLinks = (text) => {
    let matches = linkify.tlds(tlds).set({ fuzzyLink: true }).match(text);
    if (!matches) return text;
    if (matches[0]?.url) {
        matches[0].url = matches[0].url.replace('http:', 'https:');
    }
    return matches;
};

export const linkPlugin = createLinkPlugin({
    LinkReplacer: (props) => {
        const expandingProps = _.omit(props, ['category', 'action', 'target', 'to']);
        return (
            <TrackEventLink
                {...expandingProps}
                category="description"
                action="from-project-page"
                target="_blank"
                to={props.href}
            />
        );
    },
    placeholder: 'Lim inn lenke',
    urlInvalidError: 'Lenken er ugyldig!',
    AddLinkFormReplacer: (props) => (
        <div className={styles.inputAndGo}>
            <SingleInputWithOkAndCancel {...props} />
        </div>
    ),
});

export const { LinkButton } = linkPlugin;
